(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ResetPasswordWithSMSController', ResetPasswordWithSMSController);


    ResetPasswordWithSMSController.$inject = ['$translate', '$timeout', 'AuthCustom', 'PasswordCustom', '$state', 'LoginService'];

    function ResetPasswordWithSMSController($translate, $timeout, AuthCustom, PasswordCustom, $state, LoginService) {
        var vm = this;

        vm.formMode = 'Request';
        vm.requestPasswordReset = requestPasswordReset;
        vm.sendActivationCode = sendActivationCode;
        vm.changePasswordReq = {};
        vm.login = LoginService.open;

        function requestPasswordReset() {
            if (vm.changePasswordReq != null && vm.changePasswordReq.password != null)
                PasswordCustom.requestPasswordByPhoneNumber().save(vm.changePasswordReq, saveSuccess, saveError);
        }

        function saveSuccess(result) {
            vm.formMode = 'Done'
        }

        function saveError() {

        }

        function sendActivationCode() {
            if (vm.changePasswordReq.phoneNumber != null && vm.changePasswordReq.phoneNumber != undefined)
                AuthCustom.sendActivationCode(vm.changePasswordReq.phoneNumber).get(onSuccess);
        }

        function onSuccess() {
            vm.formMode = 'Activate'
        }

    }
})();
